import { IVendor } from 'contacts/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getManyAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IVendor>> => {
  const { data } = await partfinitiClient.get(
    `/contacts/vendor/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IVendor>(data.vendors, data.total_count);
};
